import React from "react";
import { AnimatePresence } from "framer-motion";
import Nav from "../components/Nav";
import Footer from "../components/Footer";
import CookieBanner from "../components/CookieBanner";
import ScrollToTop from "../utils/ScrollToTop";

// Keep the public DOM and consent component identical in both renderers.
export default function PublicPageLayout({ children }) {
  return (
    <>
      <Nav />
      <ScrollToTop />
      <div className="mm-public mm-page pt-16 md:pt-20">
        <AnimatePresence mode="wait">{children}</AnimatePresence>
      </div>
      <Footer />
      <CookieBanner />
    </>
  );
}
